var _line, _path, _rect, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMutedMicrophoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 518,
    viewBox: "0 0 518 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 263.374,
    y1: 501.503,
    x2: 263.374,
    y2: 421.967,
    stroke: "#2C2C2C",
    strokeWidth: 32,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.27 246C114.046 299.5 140.446 342 154.27 356.5C168.095 371 209.564 406 260.27 406C310.977 406 355.546 379.5 374.27 356.5C392.995 333.5 411.046 294.5 409.27 246",
    stroke: "#2C2C2C",
    strokeWidth: 32,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 183.046,
    y: 22,
    width: 160,
    height: 320,
    rx: 74,
    stroke: "#2C2C2C",
    strokeWidth: 32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 506.586,
    x2: 506.586,
    y2: 7.99999,
    stroke: "#FF3B30",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedMicrophoneIcon);
export default __webpack_public_path__ + "static/media/muted-microphone-icon.728c23bea91f69945cfdf7ef272ec3f6.svg";
export { ForwardRef as ReactComponent };